import React, { createContext, useContext, useState } from 'react'
import addeventStyle from './AddEventPage.module.css'
import CoordinatorAccordion from '../../components/Accordion/CoordinatorAccordion'
import CoordinatorPageBar from '../../components/CoordinatorPageBar/CoordinatorPageBar'
import CoordinatorMobilPageBar from '../../components/CoordinatorMobilPageBar/CoordinatorMobilPageBar'
import CoordinatorHeader from '../../components/Header/CoordinatorHeader'
import SideBar from '../../components/SideBar/SideBar'
import { DateRangePicker } from 'rsuite';
import { useMediaQuery } from 'react-responsive';
import AddEventMobilStepOne from '../addeventmobilstepone/AddEventMobilStepOne'
import AddEventMobilStepTwo from '../addeventmobilsteptwo/AddEventMobilStepTwo'

const safeJSONParse = (value, fallback) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

export default function AddEventPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [inviteSent, setInviteSent] = useState(false);
  const [eventName, setEventName] = useState('');
  const [eventDetail, setEventDetail] = useState('');
  const [eventLocation, setEventLocation] = useState('');
  const [eventNotes, setEventNotes] = useState('');

  /*const [dateRange, setDateRange] = useState(() => {
    const stored = safeJSONParse(localStorage.getItem('eventDate'), [null, null]);

    if (stored && stored.length === 2) {
      return [
        stored[0] ? createLocalDate(stored[0]) : null,
        stored[1] ? createLocalDate(stored[1]) : null
      ];
    }

    return [null, null];
  }); */

  const [dateRange, setDateRange] = useState(() => {
    const stored = safeJSONParse(localStorage.getItem('eventDate'), [null, null]);

    if (stored && stored.length === 2) {
      return [
        stored[0] ? createLocalDate(stored[0]) : null,
        stored[1] ? createLocalDate(stored[1]) : null
      ];
    }

    return [null, null];
  });

  function createLocalDate(dateStr) {
    if (!dateStr) return null;

    const [year, month, day] = dateStr.split('-');
    return new Date(year, month - 1, day); // ✅ NO timezone issue
  }

  /*function createLocalDate(dateStr) {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split('-');
    return new Date(year, month - 1, day);
  } */
  const [eventStartTime, setEventStartTime] = useState(
    localStorage.getItem('eventStarttime') || ''
  );

  const [eventEndTime, setEventEndTime] = useState(
    localStorage.getItem('eventEndtime') || ''
  );

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;

  const cordinatorID = localStorage.getItem('cordinator_id');
  const cordinatorFName = localStorage.getItem('coordinatorFName');
  const cordinatorLName = localStorage.getItem('coordinatorLName');
  const cordinatorPosition = localStorage.getItem('coordinatorPosition');
  const cordinatorPic = localStorage.getItem('coordinatorPic');
  const [hasMissingAuthors, setHasMissingAuthors] = useState(false);

  const singleData = "Hello from Page1";

  const handleChangeEN = (event) => {
    const value = event.target.value;
    setEventName(value);

    // Step 3: Store the new value in localStorage
    localStorage.setItem('eventName', value);
  };

  const handleChangeED = (event) => {
    const value = event.target.value;
    setEventDetail(value);

    // Step 3: Store the new value in localStorage
    localStorage.setItem('eventDetail', value);
  };

  const handleChangeEL = (event) => {
    const value = event.target.value;
    setEventLocation(value);

    // Step 3: Store the new value in localStorage
    localStorage.setItem('eventLocation', value);
  };

  const handleChangeN = (event) => {
    const value = event.target.value;
    setEventNotes(value);

    // Step 3: Store the new value in localStorage
    localStorage.setItem('eventNotes', value);
  };

  /*const handleDateChange = (value) => {
    if (!value || value.length !== 2) {
      setDateRange([null, null]);
      return;
    }

    const [start, end] = value;

    // FORCE LOCAL DATE (kills timezone shift)
    const localStart = new Date(
      start.getFullYear(),
      start.getMonth(),
      start.getDate()
    );

    const localEnd = new Date(
      end.getFullYear(),
      end.getMonth(),
      end.getDate()
    );

    setDateRange([localStart, localEnd]);

    localStorage.setItem(
      'eventDate',
      JSON.stringify([
        formatDateForStorage(localStart),
        formatDateForStorage(localEnd)
      ])
    );
  }; */

  const handleDateChange = (value) => {
    if (!value || value.length !== 2) {
      setDateRange([null, null]);
      localStorage.removeItem('eventDate');
      return;
    }

    const [start, end] = value;

    // Convert to SAFE STRING format
    const startStr = formatDateForStorage(start);
    const endStr = formatDateForStorage(end);

    // Store ONLY STRINGS
    localStorage.setItem(
      'eventDate',
      JSON.stringify([startStr, endStr])
    );

    // Convert back to local Date for UI
    setDateRange([
      createLocalDate(startStr),
      createLocalDate(endStr)
    ]);
  };

  function formatDateForStorage(date) {
    if (!date) return '';

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  /* function formatDateForStorage(date) {
     if (!date) return '';
 
     const yyyy = date.getFullYear();
     const mm = String(date.getMonth() + 1).padStart(2, '0');
     const dd = String(date.getDate()).padStart(2, '0');
 
     return `${yyyy}-${mm}-${dd}`;
   } */

  const handleStartTimeChange = (e) => {
    const start = roundTo15(e.target.value);

    setEventStartTime(start);
    localStorage.setItem('eventStarttime', start);

    // Reset end time if it's now invalid
    if (eventEndTime && eventEndTime <= start) {
      setEventEndTime('');
      localStorage.removeItem('eventEndtime');
    }
  };

  const handleEndTimeChange = (e) => {
    const end = roundTo15(e.target.value);

    if (eventStartTime && end <= eventStartTime) {
      alert('End time must be greater than start time');
      return;
    }

    setEventEndTime(end);
    localStorage.setItem('eventEndtime', end);
  };


  const roundTo15 = (time) => {
    if (!time) return '';

    const [h, m] = time.split(':').map(Number);
    const total = h * 60 + m;
    const rounded = Math.round(total / 15) * 15;

    const hours = Math.floor(rounded / 60) % 24;
    const minutes = rounded % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };

  const timeOptions = Array.from({ length: 96 }, (_, i) => {
    const h = String(Math.floor(i / 4)).padStart(2, '0');
    const m = String((i % 4) * 15).padStart(2, '0');
    return `${h}:${m}`;
  });

  // Handle "Next" button click
  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };



  return (
    <>
      <CoordinatorHeader />
      {isMobile ? (
        <div className={addeventStyle.addeventmobiltopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorMobilPageBar />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={addeventStyle.addeventdesktoptopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorPageBar />
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        <div className={addeventStyle.addeventmobilpage}>
          <div className='container'>
            <div className='row'>
              <div className="col-lg-12">
                {currentStep === 1 && (
                  <AddEventMobilStepOne onNext={nextStep} nextLabel="Next - Author Details" />
                )}
                {currentStep === 2 && (
                  <AddEventMobilStepTwo onNext={nextStep} />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={addeventStyle.addeventdesktoppage}>
          <div className='container'>
            <div className='row'>
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar degination={cordinatorPosition} uname={cordinatorFName} ulname={cordinatorLName} userid={cordinatorID} />
              </div>
              <div className="col">
                <div className={addeventStyle.addeventpageWrap}>
                  <h4> Events </h4>
                  <div className='row'>
                    <div className='col-lg-12'>
                      <div className="row">
                        <div className="col-lg-6 mb-3">
                          <label className={`${addeventStyle.addeventLabel} form-label`}>Event Name</label>
                          <input type="text" className={`${addeventStyle.addeventInput} form-control`} onChange={handleChangeEN} placeholder="Type name of event" />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className={`${addeventStyle.addeventLabel} form-label`}>
                            Start and End Date
                          </label>
                          <DateRangePicker
                            appearance="default"
                            placeholder="Start and End Date"
                            onChange={handleDateChange}
                            style={{ width: '100%' }}
                            className={addeventStyle.addeventDate}
                            disabledDate={(date) => date < new Date().setHours(0, 0, 0, 0)}
                            format="MM/dd/yyyy"           // <-- This forces MM/DD/YYYY
                            isoWeek={false}               // optional: keeps week start as Sunday
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 mb-3">
                          <label className={`${addeventStyle.addeventLabel} form-label`}>
                            Start Time
                          </label>
                          <select className={`${addeventStyle.starttimeinput} form-control`}
                            value={eventStartTime}
                            onChange={(e) => handleStartTimeChange(e)}>
                            <option value="">Start time</option>
                            {timeOptions.map(t => (
                              <option key={t} value={t}>{t}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-lg-6 mb-3">
                          <label className={`${addeventStyle.addeventLabel} form-label`}>
                            End Time
                          </label>
                          <select className={`${addeventStyle.starttimeinput} form-control`}
                            value={eventEndTime}
                            onChange={handleEndTimeChange}
                          >
                            <option value="">End time</option>
                            {timeOptions
                              .filter(t => !eventStartTime || t > eventStartTime)
                              .map(t => (
                                <option key={t} value={t}>{t}</option>
                              ))}
                          </select>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 mb-3">
                          <label className={`${addeventStyle.addeventLabel} form-label`}>Event Details</label>
                          <input type="text" className={`${addeventStyle.addeventInput} form-control`} onChange={handleChangeED} placeholder="Enter grade/age levels" />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className={`${addeventStyle.addeventLabel} form-label`}>&nbsp;</label>
                          <input type="text" className={`${addeventStyle.addeventInput} form-control`} onChange={handleChangeEL} placeholder="Enter location" />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col mb-3">
                          <label className={`${addeventStyle.addeventLabel} form-label`}>Notes</label>
                          <textarea className={`${addeventStyle.addeventInput} form-control`} rows="4" onChange={handleChangeN} placeholder=''></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={addeventStyle.addeventauthorWrap}>
                  <h4> Author's </h4>
                  <CoordinatorAccordion eventName={eventName} dateRange={dateRange} onAuthorMissingChange={setHasMissingAuthors} onInviteSent={() => setInviteSent(true)} />
                </div>
              </div>
              <div className="col-2">
                {hasMissingAuthors && !inviteSent && (
                  <div className={addeventStyle.mainrightdv}>
                    <div className={addeventStyle.addeventredbx}>
                      <h4>Sorry, author not found or registered</h4>
                      <p> We’re sorry, but the author you’re searching for isn’t currently found or registered in our system.
                        Please send them an invitation to register to AuthorMeet by clicking on the <b>“Send Invite”</b> button.
                      </p>
                      <p>In the meantime, you can still go ahead and submit your event request.</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
